/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import AppTable from 'components/appTable';
import Thumb from 'components/thumb';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import PaginationApp from 'components/pagination';
import { useActions } from 'common/hooks/useActions';
import { useNavigate } from 'react-router';
import { menuCategoryArray } from 'common/enums';

import StatusChip from 'components/statusChip';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  menuList: { list: T.Pages.CafeteriaListItem[]; totalPages: number };
  loading: boolean;
}

export default function CafeteriaMenuManagementTable({ menuList, loading }: IProps) {
  const { cafeteriaMenuManagementRequestAction } = useActions();
  // const [showEditModal, setShowEditModal] = useState(false);
  // const [editData, setEditData] = useState<T.Pages.CafeteriaListItem | null>();
  const [meta, setMeta] = useState({
    page: 1,
    take: 10,
    search: '',
    type: ''
  });

  const navigate = useNavigate();

  const fetchData = () => {
    cafeteriaMenuManagementRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  // const handleShowEdit = (item: T.Pages.CafeteriaListItem) => {
  //   setShowEditModal(true);
  //   setEditData(item);
  // };

  // const handleCloseEdit = () => {
  //   setShowEditModal(false);
  //   setEditData(null);
  // };

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangeTake = (take: number) => {
    setMeta({ ...meta, take });
  };

  const renderCategoryName = (cat: string) => {
    let newText: string = '';
    // -- //
    // eslint-disable-next-line array-callback-return
    menuCategoryArray.map((item: any) => {
      if (item.id === cat) newText = item.title;
    });
    return newText;
  };

  const handleFilter = (field: string, val: string | number) => {
    setMeta({ ...meta, page: 1, [field]: val });
  };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox onChange={(e) => handleFilter('search', e)} placeholder="Search" value={meta.search} />
          <S.FilterButoons>
            <S.Button onClick={() => handleFilter('type', '')} className={meta.type === '' ? 'active' : ''}>
              All
            </S.Button>
            {menuCategoryArray.map((item) => (
              <S.Button onClick={() => handleFilter('type', item.id)} className={meta.type === item.id ? 'active' : ''}>
                {item.title}
              </S.Button>
            ))}
          </S.FilterButoons>
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, key: 'id', title: 'ID', dir: 'left', width: 84 },
            { id: 2, key: 'icon', title: 'Icon', width: 64 },
            { id: 3, key: 'title', title: 'Title', dir: 'left' },
            { id: 4, key: 'category', title: 'Category', dir: 'left', width: 150 },
            { id: 5, key: 'status', title: 'Status', dir: 'left', width: 120 },
            { id: 6, key: 'count', title: 'Orders Count', type: 'num', width: 120 },
            { id: 7, key: 'edit', title: 'Edit', type: 'actions', width: 72 }
          ]}
          style={{ minWidth: 'auto' }}
          data={menuList?.list}
          loading={loading}
          altanfeethiFields={{
            id: (item: T.Pages.CafeteriaListItem) => <S.Div className="text-left">{item?.id}</S.Div>,
            icon: (item: T.Pages.CafeteriaListItem) => (
              <S.Div className="flex-center">
                <Thumb
                  src={item.image}
                  name={item?.menuTranslations?.find((t: any) => t.language === 'en')?.translate}
                />
              </S.Div>
            ),
            title: (item: T.Pages.CafeteriaListItem) => (
              <S.Div className="text-left">
                {item?.menuTranslations?.find((t: any) => t.language === 'en')?.translate || ''}
              </S.Div>
            ),
            category: (item: T.Pages.CafeteriaListItem) => (
              <S.Div className="text-left">{renderCategoryName(item.category)}</S.Div>
            ),
            status: (item: T.Pages.CafeteriaListItem) => (
              <S.Div className="text-left">
                <StatusChip domain="menuItem" value={Boolean(item.status)} />
              </S.Div>
            ),
            count: (item: T.Pages.CafeteriaListItem) => item.ordersCount,
            edit: (item: T.Pages.CafeteriaListItem) => (
              <S.Div
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(`/panel/cafeteria/menu-management/${item?.id}`)}
              >
                {/* <Link to={`/panel/cafeteria/menu-management/${item.id}`}> */}
                <ReactSVG
                  src="/icons/stroke/pen-card.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('stroke', `#8A93AC`);
                  }}
                />
                {/* </Link> */}
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {menuList?.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.take * menuList.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={menuList.totalPages}
          pageSize={meta.take}
          handleChangeTake={handleChangeTake}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
